import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ConferenceView, getConferenceOptions } from '@/module/Conference';

export const Route = createFileRoute('/_auth/conference/_conference/$conferenceId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { conferenceId } = Route.useParams();
  const { data: conference } = useSuspenseQuery(getConferenceOptions(conferenceId));

  return <ConferenceView conference={conference} />;
}
